import { handleActions, createAction } from 'redux-actions';

import {
  AgentStatus,
  AgentProviders,
  ChannelType,
  ChannelStatus,
  CLIENT_ORIGIN_WS_EVENTS,
} from '../constants';

import { getStore } from '../store/helpers';
import { getPrimus } from '../utils/primus';

export const setCollection = createAction('app/SET_COLLECTION');

/**
 * Checks if there are any SMS channels in hold, that need to be approved:
 * (if balance > 20 usd/eur - triggers approval flow on backend by setting status to CREATED).
 */
export const proceedChannelsApprove = createAction(
  'app/PROCEED_CHANNELS_APPROVE',
  () => {
    const store = getStore();

    const {
      user: { balance, credit_balance, reserved_balance },
      channel_manager: { agents },
    } = store.getState();

    const currentBalance = balance + credit_balance - reserved_balance;

    const createdAgents = agents.filter(
      ({ status, provider }) =>
        status === AgentStatus.HOLD &&
        provider === AgentProviders[ChannelType.SMS].IZONET
    );

    if (currentBalance / 100 >= 20 && createdAgents.length > 0) {
      const primus = getPrimus();

      createdAgents.forEach((agent) => {
        primus.emit(
          CLIENT_ORIGIN_WS_EVENTS.COLLECTION,
          { cid: 'agents' },
          { ...agent, status: AgentStatus.CREATED }
        );
      });
    }
  }
);

export const channel_manager = handleActions(
  {
    [setCollection]: (state, { payload: { data, coll } }) => {
      const temp = [...state[coll]];

      data.forEach((cur) => {
        const index = temp.findIndex(({ id }) => id === cur.id);

        if (index === -1) {
          temp.push(cur);
        } else {
          temp[index] = cur;
        }
      });

      const newState = {
        ...state,
        [coll]: temp.filter(({ status }) => status !== ChannelStatus.REMOVED),
      };

      if (coll === 'channels') {
        newState.isLoading = false;
      }

      return newState;
    },
  },
  {
    isLoading: true,
    channels: [],
    agents: [],
  }
);
